module.exports = __webpack_public_path__ + "img/general-bg-4.01b93ecc.svg";